import store from "../redux/redux"

const coreupdate = (type:any) => {
    store.dispatch({type})
}

export {
    coreupdate,
}